// when we encrypt map points, we just have space-separated x and y coords
import { MapPoint } from "../types/scheduling/territory";
import { DefaultSrid } from "../helpers/geo";

export function parseLocation(ls: string): MapPoint | undefined {
  const xy = ls.split(" ", 2);
  if (xy.length === 2 && xy[0] && xy[1]) {
    const x = parseFloat(xy[0]);
    const y = parseFloat(xy[1]);
    return { x: x, y: y, srid: DefaultSrid };
  }
  return;
}
